<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 4A16.49 16.49 0 007.53 20.51c0 7.34 10.64 18.65 14.82 22.81a2.34 2.34 0 003.3 0c4.18-4.16 14.82-15.47 14.82-22.81A16.49 16.49 0 0024 4zm0 36.73c-8.32-8.38-13.47-16.09-13.47-20.22a13.47 13.47 0 1126.94 0c0 4.13-5.15 11.84-13.47 20.22z"/><path d="M30.21 18.71l-3.35-3.34-2.06-2.07a1.13 1.13 0 00-1.58 0l-2.06 2.07-3.35 3.34-1.45 1.45a1.12 1.12 0 00.79 1.91h13.72a1.12 1.12 0 00.79-1.91z"/></svg>